var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAlert(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 120,
    fill: ""
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M74.6842 52.3684C63.5191 52.3684 54.4386 61.4489 54.4386 72.614C54.4386 83.7791 63.5191 92.8596 74.6842 92.8596C85.8493 92.8596 94.9298 83.7791 94.9298 72.614C94.9298 61.4489 85.8493 52.3684 74.6842 52.3684ZM74.6842 97.9298C60.7278 97.9298 49.3684 86.5704 49.3684 72.614C49.3684 58.6576 60.7278 47.2982 74.6842 47.2982C88.6406 47.2982 100 58.6576 100 72.614C100 86.5704 88.6406 97.9298 74.6842 97.9298Z",
    fill: "#F3923D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M74.6842 47.3159H21.5263V52.3861H74.6842V47.3159Z",
    fill: "#F3923D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0702 47.3159H19V67.5614H24.0702V47.3159Z",
    fill: "#F3923D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9564 65.0497L21.1231 70.051L51.4967 75.112L52.33 70.1107L21.9564 65.0497Z",
    fill: "#F3923D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M46.8598 49.8421H41.7895V59.9649H46.8598V49.8421Z",
    fill: "#F3923D"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M46.8598 22H41.7895V39.7193H46.8598V22Z",
    fill: "#F3923D"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M57.7142 30.3342L50.119 37.9293L53.7042 41.5145L61.2993 33.9194L57.7142 30.3342Z",
    fill: "#F3923D"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M30.9294 30.3247L27.3442 33.9099L34.9393 41.505L38.5245 37.9198L30.9294 30.3247Z",
    fill: "#F3923D"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M74.6842 62.5088C69.1016 62.5088 64.5614 67.0491 64.5614 72.6316C64.5614 78.2142 69.1016 82.7544 74.6842 82.7544C80.2667 82.7544 84.807 78.2142 84.807 72.6316C84.807 67.0491 80.2667 62.5088 74.6842 62.5088ZM74.6842 87.8246C66.3104 87.8246 59.4912 81.0054 59.4912 72.6316C59.4912 64.2578 66.3104 57.4386 74.6842 57.4386C83.058 57.4386 89.8772 64.2578 89.8772 72.6316C89.8772 81.0054 83.058 87.8246 74.6842 87.8246Z",
    fill: "#F3923D"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlert);
export default __webpack_public_path__ + "static/media/alert.e9747a67d4c428a74049e731f3538649.svg";
export { ForwardRef as ReactComponent };